import Get from 'lodash/get';

export const isLoading = state => Get(state, 'shipNt.loading');
export const getShipNtData = state => Get(state, 'shipNt.shipNtData');
